module.exports = {
    routeTree: {
        missingRoutesLanguageConnections: 'Die Verbindung zu den folgenden Sprachen ist für diese Route nicht definiert worden:\n\n{{langCodes}}',
        nonUniqueRouteLanguage: 'Die Verbindung zu den folgenden Sprachen ist für diese Route nicht eindeutig:\n\n{{langCodes}}',
        missingRouteLanguage: 'Routen in der obersten Ebene muss eine Sprache zugeordnet werden!',
        routesLanguageConnectionNotAssignable: 'Der gewählten Route ist die Sprache \'{{targetLangCode}}\' zugewiesen, müsste aber aus dem Sprach-Knoten \'{{sourceLangCode}}\' stammen!',
        missingAvailableLangCodes: 'Dem Projekt wurden keine Sprachen konfiguriert.',
        missingTemplateID: 'Routen in der obersten Ebene muss ein Layout zugeordnet werden!',
    },
    routeContentTree: {
        moveToAnotherRoute: {
            common: 'Beim Verschieben des Elements ist ein Fehler aufgetreten!',
            sourceToTargetDependency: 'Das Ziel darf weder das Quell-Element noch ein Kind davon sein!',
        },
        duplicateMasterComponent: {
            invalidElementType: 'Nur Vorlagen-Elemente (Komponenten) können kopiert werden!',
        },
        loadMissingRoute: 'Die Route konnte leider nicht mehr geladen werden. Vermutlich wurde sie in der zwischenzeit von jemandem gelöscht.',
    },
    layoutTree: {
        sortMeta: {
            targetNodeNotFound: 'Ihr Element konnte am angegebenen Ziel nicht eingefügt werden. Vermutlich wurde der Ziel-Element in der zwischenzeit von jemandem gelöscht.',
        },
    },
    newsletter: {
        subscriber: {
            insert: {
                missingMailingList: 'Bitte wählen Sie eine Mailingliste!',
                emailExists: 'In der gewählten Mailingliste existiert bereits ein Kontakt mit dieser Email-Adresse!',
            },
            import: {
                missingPropertyChanges: {
                    setProperties: 'Bitte wählen Sie Eigenschaften die den später über den Import identifizierten Empfängern überschrieben werden sollen.',
                    removeProperties: 'Bitte wählen Sie Eigenschaften die den später über den Import identifizierten Empfängern entfernt werden sollen.',
                },
            },
        },
        mailings: {
            segments: {
                insert: {
                    mailingListConflictInSegments: 'Sie können immer nur Segmente einer einzelnen Mailingliste innerhalb einer Aussendung verwenden!',
                },
            },
        },
        mailingUrls: {
            showEdit: {
                subscribers: {
                    empty: 'Keine Empfänger anzuzeigen!',
                },
            },
        },
    },
    ttgShop: {
        products: {
            showEdit: {
                subProducts: {
                    empty: 'Keine Sub-Produkte anzuzeigen!',
                },
            },
        },
    },
    delete: {
        artcrm_addresses: {
            foreignKey: {
                default: 'Die Adresse konnte leider nicht gelöscht werden, weil sie noch mit einem anderen Datensatz verbunden ist.',
                artcrm_trips: 'Die Adresse konnte leider nicht gelöscht werden, weil sie in mindestens einem Reise-Datensatz verwendet wird.',
                artcrm_cooperations: 'Die Adresse konnte leider nicht gelöscht werden, weil sie in mindestens einem Kooperations-Datensatz verwendet wird.',
            },
        },
        artcrm_addressConnections: 'Beim Löschen der Verbindung ist ein Fehler aufgetreten!',
        artform_addresses: {
            noMatchingElementsFound: 'Es konnten keine Adressen zum Löschen identifiziert werden!',
        },
    },
    refresh: {
        artcrm_addresses: {
            missingPrimaryKey: 'Diese Adresse wurde noch nicht gespeichert!',
        },
    },
    setProcessed: {
        artform_addresses: {
            noMatchingElementsFound: 'Es konnten keine Adressen zum Markieren identifiziert werden!',
        },
    },
    export: {
        newsletter: {
            subscribers: {
                noExportWithoutSegmentID: 'Um Fehler beim erneuten Beschicken der hier exportierten Empfänger zu vermeiden, können nur Empfänger aus Segmenten exportiert werden. Bitte konfigurieren Sie die Filter dementsprechend um fortzufahren.',
            },
        },
    },
    showMove: {
        sectionComponent: {
            toLayout: 'Sektions-Komponenten können nicht direkt in einem Layout platziert werden!',
        },
    },
    moveTo: {
        sectionComponent: {
            before: {
                missingSectionComponentSelection: 'Es muss erst eine Ziel-Komponente gewählt werden vor der die Quell-Komponente eingefügt werden soll!',
            },
            after: {
                missingSectionComponentSelection: 'Es muss erst eine Ziel-Komponente gewählt werden nach der die Quell-Komponente eingefügt werden soll!',
            },
        },
    },
    upsert: {
        mblxProducts: {
            uniqueArticleNumberViolation: 'Es existiert bereits ein Produkt mit dieser Artikel-Nummer!',
        },
    },
    mblx: {
        reports: {
            uploadErrorDueToInvalidConfig: 'Die Konfiguration des Generators ist fehlerhaft. Bitte wenden Sie sich an den Administrator!',
            uploadErrorDueToInvalidInput: 'Die hochgeladene Datei konnte nicht richtig interpretiert werden. Bitte überprüfen Sie das Format und den Aufbau!',
            invalidExtension: 'Die hochgeladene Datei ist keine XLSX-Datei. Bitte passen Sie das Dateiformat an.',
            uploadErrorDueToMissingHeader: 'In der hochgeladenen Datei konnte die Überschriftenzeile nicht gefunden werden!',
            uploadCompleteButMissingData: 'Beim Generieren des Berichts ist ein Fehler aufgetreten!',
            uploadUnknownError: 'Beim Erstellen des Berichts ist ein Fehler aufgetreten!',
            missingFile: 'Bitte geben Sie eine Datei an die zum Generieren des Berichts verwendet werden soll.',
            missingUploader: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte wenden Sie sich an den Administrator!',
        },
        productAdditionalInformation: {
            importerUploader: {
                nrOfInvalidRows: '{{nrOfInvalidRows}} ungültig formatierte Einträge gefunden.',
                errorCodes: {
                    MBLX_PRODUCTS_ADDITIONAL_INFORMATION_IMPORTER_INSUFFICIENT_PRIVILEGES_ERROR: 'Sie haben nicht die nötigen Rechten diesen Importer zu verwenden.',
                    MBLX_PRODUCTS_ADDITIONAL_INFORMATION_IMPORTER_MISSING_FILE_ERROR: 'Beim hochladen der Datei ist ein Fehler aufgetreten.',
                    MBLX_PRODUCTS_ADDITIONAL_INFORMATION_IMPORTER_NO_VALID_DATA_FOUND_ERROR: 'Ungültiges Dateiformat. Bitte importieren Sie nur CSV-Dateien mit Komma-Separator.',
                },
            },
            requestProductAdditionalInformation: {
                transport: 'Beim Transportieren der Daten zum Generieren der KI-Texte ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
                insufficientRights: 'Ihnen fehlen die nötigen Rechte zum Generieren der KI-Texte.',
                missingNumber: 'Ohne Artikel-Nummer können keine KI-Texte generiert werden.',
                invalidType: 'Der angegebene Modus zum Generieren der KI-Texte wird nicht unterstützt.',
                unknown: 'Beim Generieren der KI-Texte ist ein unerwarteter Fehler aufgetreten. Bitte wenden Sie sich an den Administrator!',
            },
        },
    },
    protocol: {
        protocol: {
            unableToOpenDeleteProtocolAction: 'Zum Löschvorgang eines Elements sind keine zusätzlichen Informationen verfügbar.',
            unableToOpenUpdateMoveProtocolAction: 'Zum Verschieben eines Elements sind keine zusätzlichen Informationen verfügbar.',
            errorDuringComponentStructurePreparation: 'Beim Laden der Struktur dieser Komponente ist ein Fehler aufgetreten. Dieser Fehler sollte bei Datensätzen, die am 10.03.2023 oder später entstanden sind nicht mehr auftreten.',
        },
    },
    ninjaModules: {
        events: {
            table: {
                showEdit: {
                    missingEntry: 'Dieser Event-Eintrag konnte nicht gefunden werden. Vermutlich wurde er seit der letzten Datenaktualisierung gelöscht.',
                    missingRoute: 'Die Route zu diesem Event-Eintrag konnte nicht gefunden werden. Vermutlich wurde sie seit der letzten Datenaktualisierung gelöscht.',
                }
            }
        },
        news: {
            table: {
                showEdit: {
                    missingEntry: 'Dieser News-Eintrag konnte nicht gefunden werden. Vermutlich wurde er seit der letzten Datenaktualisierung gelöscht.',
                    missingRoute: 'Die Route zu diesem News-Eintrag konnte nicht gefunden werden. Vermutlich wurde sie seit der letzten Datenaktualisierung gelöscht.',
                },
            },
        },
        customers: {
            table: {
                showEdit: {
                    missingEntry: 'Dieser Kunden-Datensatz konnte nicht gefunden werden. Vermutlich wurde er seit der letzten Datenaktualisierung gelöscht.',
                    missingRoute: 'Die Route zu diesem Kunden-Datensatz konnte nicht gefunden werden. Vermutlich wurde sie seit der letzten Datenaktualisierung gelöscht.',
                },
            },
        },
    },
    livecom: {
        members: {
            duplicateUserCode: 'Der angegebene Benutzername ist bereits vergeben. Bitte wählen Sie einen anderen.',
        },
    },
    artCrm: {
        addresses: {
            export: {
                newsletterWithoutEmailsWillBeEmptyAllTheTime: {
                    message: 'Der Filter "Newsletter-Email": Nein wird in jedem Fall dafür sorgen, dass dieser Export leer ist.'
                }
            }
        }
    }
}
